import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { SharedModule } from './shared/shared.module';
import { ContentLayoutComponent } from './layout/content-layout/content-layout.component';

@Component({
  selector: 'app-root',
  imports: [
    //RouterOutlet,
    ContentLayoutComponent
  ],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  protected readonly title = signal('production-coordinator');
}
